import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-dark-lighter/70 backdrop-blur-md border-t border-accent shadow-lg">
      <div className="container mx-auto py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold text-white mb-4">nautdigital</h3>
            <p className="text-gray-400">
              Empowering you with technology
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-gray-400 hover:text-accent transition-colors">
                  Our specialities
                </Link>
              </li>
              <li>
                <Link to="/process" className="text-gray-400 hover:text-accent transition-colors">
                  Our methodology
                </Link>
              </li>
              <li>
                <Link to="/technical-assessment" className="text-gray-400 hover:text-accent transition-colors">
                  Technical assessment
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-accent transition-colors">
                  Contact us
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-xl font-bold text-white mb-4">Our Policies</h3>
            <ul>
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-accent transition-colors">
                  Privacy policy
                </Link>
              </li>
              <li>
                <Link to="/cookies-policy" className="text-gray-400 hover:text-accent transition-colors">
                  Cookies policy
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" className="text-gray-400 hover:text-accent transition-colors">
                  Terms and conditions
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <ul className="space-y-2 text-gray-400">
              <li>Made in London, UK ❤️</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} nautdigital. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 